// state object
export default {
  unread: 0
};
